var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03851 14.7783C3.94744 14.7783 0.651855 11.4827 0.651855 7.39166C0.651855 3.30059 3.94744 0.00500488 8.03851 0.00500488C12.1296 0.00500488 15.4252 3.30059 15.4252 7.39166C15.4252 11.4827 12.1296 14.7783 8.03851 14.7783ZM8.03851 1.14141C4.57247 1.14141 1.78826 3.92562 1.78826 7.39166C1.78826 10.8577 4.57247 13.6419 8.03851 13.6419C11.5046 13.6419 14.2888 10.8577 14.2888 7.39166C14.2888 3.92562 11.5046 1.14141 8.03851 1.14141Z",
    fill: "#BCBCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5398 12.0889L18.6422 17.1914L17.8388 17.9948L12.7363 12.8924L13.5398 12.0889Z",
    fill: "#BCBCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.6e82b7fedfc49ee837e73c7a6bcd2fa2.svg";
export { ForwardRef as ReactComponent };